import React from 'react'
import { EmptyState } from '../EmptyState'
import type { EmptyStateProps } from '../EmptyState/EmptyState'

export type TBodyProps = React.ComponentPropsWithoutRef<'tbody'> & {
  emptyVariant?: EmptyStateProps['variant']
  emptySize?: 'default' | 'small'
  emptyMessage?: string
  EmptyState?: React.ReactNode
  emptyStateAndMessage?: boolean
}

export function TBody({
  emptySize,
  emptyVariant,
  emptyMessage,
  EmptyState: _EmptyState,
  emptyStateAndMessage = false,
  ...rest
}: TBodyProps) {
  return (
    <tbody {...rest}>
      {React.Children.count(rest.children) ? (
        rest.children
      ) : !!_EmptyState && !emptyStateAndMessage ? (
        _EmptyState
      ) : (
        <tr>
          <td colSpan={'100%' as any}>
            <div
              css={`
                  height: ${emptySize === 'small' ? '200px' : '400px'};
                  background-color: var(--white);
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                `}
            >
              <EmptyState
                variant={emptyVariant}
                height={emptySize === 'small' ? '50' : undefined}
                width={emptySize === 'small' ? '50' : undefined}
              >
                {emptyMessage}
                {_EmptyState}
              </EmptyState>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  )
} 